// Use a public endpoint for health checks in production to avoid 401 errors
const _getHealthUrl = (): string => {
  const baseUrl = import.meta.env.VITE_SUPABASE_URL?.replace(/\/$/, '');
  // Always use the Auth health endpoint for health checks to avoid 401 on /rest/v1/
  return baseUrl + '/auth/v1/health';
};

// TEMPORARILY DISABLED: Server status health check (see debugging notes)
export function useServerStatusToast(): void {
  /*
  const hasShownRef = useRef(false);

  useEffect(() => {
    let didCancel = false;
    const checkHealth = async () => {
      try {
        // Always omit credentials for health check to avoid 401
        const res = await fetch(getHealthUrl(), {
          method: "GET",
          credentials: "omit",
        });
        if (!didCancel && !res.ok && !hasShownRef.current) {
          showErrorToast(
            "Unable to connect to the server",
            "Some features may not work. Please try again later or check your connection."
          );
          hasShownRef.current = true;
        }
      } catch {
        if (!didCancel && !hasShownRef.current) {
          showErrorToast(
            "Unable to connect to the server",
            "Some features may not work. Please try again later or check your connection."
          );
          hasShownRef.current = true;
        }
      }
    };
    checkHealth();
    // Optionally, poll every 30s
    const interval = setInterval(checkHealth, 30000);
    return () => {
      didCancel = true;
      clearInterval(interval);
    };
  }, []);
  */
}
